module.exports = __webpack_public_path__ + "img/rob_dianjian.ebbba486.png";